import { graphql } from '@/graphql-setup'

export const WORK_DAY_INFRINGEMENT_QUERY = graphql(`
  query WorkDayInfringement($id: ID!) {
    workDayInfringement(id: $id) {
      id
      createdAt
      reasonValue
      secondaryReasonValue
      periodStartDate
      periodEndDate
      infringementTimestamp
      archivedAt
      archivedBasis
      user {
        id
        fullName
        phoneNumber
      }
      workInfringementCategory {
        id
        identifier
        title
        description
        legalBasis
      }
      segments {
        id
        segmentType
        datetimeStart
        datetimeEnd
      }
    }
  }
`)

export const ALL_WORK_DAY_INFRINGEMENTS_QUERY = graphql(`
  query AllWorkDayInfringements(
    $first: Int
    $after: String
    $users: [ID]
    $q: String
    $orderBy: String
    $archivedAt_Isnull: Boolean
    $infringementTimestamp_Lt: DateTime
    $infringementTimestamp_Gte: DateTime
    $leaderGroupId: ID
  ) {
    allWorkInfringements(
      first: $first
      after: $after
      users: $users
      q: $q
      orderBy: $orderBy
      archivedAt_Isnull: $archivedAt_Isnull
      infringementTimestamp_Lt: $infringementTimestamp_Lt
      infringementTimestamp_Gte: $infringementTimestamp_Gte
      leaderGroupId: $leaderGroupId
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          workInfringementCategory {
            id
            identifier
            title
            legalBasis
          }
          infringementTimestamp
          archivedAt
          archivedBasis
          user {
            id
            fullName
            phoneNumber
          }
        }
      }
    }
  }
`)
